module.exports = __webpack_public_path__ + "img/horizontal.484f46ea.jpg";